import React from 'react';

import { mapProductToTrackingProduct } from '../../../content/sections/productCarouselRecommendations/mapProductToTrackingProduct';
import { trackCarouselNavigation } from '../../../tracking/common/carousel';
import { trackProductClick, trackProductImpression } from '../../../tracking/common/products';
import type { TrackingContext } from '../../../types/TrackingContext';
import { SectionContainer } from '../../molecules/SectionContainer';
import type { ProductCarouselRecommendationsProps } from '../../organisms/ProductCarouselRecommendations';
import { ProductCarouselRecommendations } from '../../organisms/ProductCarouselRecommendations';
import * as styles from './ProductCarouselRecommendationsSection.style';

export interface ProductCarouselRecommendationsSectionProps
  extends ProductCarouselRecommendationsProps {
  trackingTitle: string;
  trackingPosition?: number;
  hasDisabledCookies: boolean;
}

export const ProductCarouselRecommendationsSection = ({
  trackingPosition,
  placementType,
  currency,
  ...restOfProps
}: ProductCarouselRecommendationsSectionProps) => {
  const trackingContext: Omit<TrackingContext, 'trackingTitle'> = {
    trackingContentType: 'Rich Relevance',
    trackingPosition,
  };

  return (
    <SectionContainer wrapperStyles={styles.wrapper} maxWidth="max" columnsXL={10}>
      <ProductCarouselRecommendations
        currency={currency}
        placementType={placementType}
        onVisible={({ products, strategy }) => {
          trackProductImpression({
            ...trackingContext,
            products: products.map((product) => mapProductToTrackingProduct(product, currency)),
            trackingTitle: `${strategy} : ${placementType}`,
          });
        }}
        onNavigateCarousel={(swiped, control, { numberOfItems, strategy }) => {
          const trackingDirection = control === 'next' ? 'next' : 'previous';

          trackCarouselNavigation(swiped, trackingDirection, {
            ...trackingContext,
            numberOfItems,
            trackingTitle: `${strategy} : ${placementType}`,
          });
        }}
        onProductClick={(
          e,
          { product, index, numberOfItems, strategy, recommendationsTrackingUrl },
        ) => {
          trackProductClick(e, {
            ...trackingContext,
            recommendationsTrackingUrl,
            product: mapProductToTrackingProduct(product, currency),
            productIndex: index,
            numberOfItems,
            trackingTitle: `${strategy} : ${placementType}`,
          });
        }}
        {...restOfProps}
      />
    </SectionContainer>
  );
};

export type { ProductCarouselRecommendationsProps };
